var _path, _circle;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpgrade = function SvgUpgrade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 3.52002L3.83984 7.85752H6.45184V10.6347H9.54785V7.85752H12.1598L7.99984 3.52002ZM9.03185 7.34493V10.1221H6.96784V7.34493H5.04419L7.99984 4.26327L10.9555 7.34493H9.03185ZM6.45184 11.0448H9.54785V11.5574H6.45184V11.0448ZM6.45184 11.9674H9.54785V12.48H6.45184V11.9674Z",
    fill: "#031FEF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00047,
    cy: 7.99998,
    r: 7.02,
    stroke: "#031FEF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpgrade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upgrade.a8a03259.svg";
export { ForwardRef as ReactComponent };